import { axios, baseURL } from '@axios'
import encryptionService from '@/services/encryption.service'
import { DirectUpload } from '@rails/activestorage'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchLeads(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/leads', { params: queryParams })
          .then(response => (resolve(response)))
          .catch(error => reject(error))
      })
    },
    fetchLead(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/leads/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createLead(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/v1/leads', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateLead(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/leads/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidLead(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/leads/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    directUploadPolicy(ctx, file) {
      return new Promise((resolve, reject) => {
        const url = `${baseURL}/direct_uploads?referer=previous_policy`
        const upload = new DirectUpload(file, url, {
          directUploadWillCreateBlobWithXHR: xhr => {
            const authHeaders = JSON.parse(encryptionService.decrypt(localStorage.getItem('authHeaders')))
            if (authHeaders) {
              xhr.setRequestHeader('access-token', authHeaders.accessToken)
              xhr.setRequestHeader('token-type', authHeaders.tokenType)
              xhr.setRequestHeader('client', authHeaders.client)
              xhr.setRequestHeader('expiry', authHeaders.expiry)
              xhr.setRequestHeader('uid', authHeaders.uid)
            }
          },
        })

        upload.create((error, blob) => {
          if (error) reject(error)
          else resolve(blob)
        })
      })
    },
    directUploadLeadDocuments(ctx, file) {
      return new Promise((resolve, reject) => {
        const url = `${baseURL}/direct_uploads?referer=lead_documents`
        const upload = new DirectUpload(file, url, {
          directUploadWillCreateBlobWithXHR: xhr => {
            const authHeaders = JSON.parse(encryptionService.decrypt(localStorage.getItem('authHeaders')))
            if (authHeaders) {
              xhr.setRequestHeader('access-token', authHeaders.accessToken)
              xhr.setRequestHeader('token-type', authHeaders.tokenType)
              xhr.setRequestHeader('client', authHeaders.client)
              xhr.setRequestHeader('expiry', authHeaders.expiry)
              xhr.setRequestHeader('uid', authHeaders.uid)
            }
          },
        })

        upload.create((error, blob) => {
          if (error) reject(error)
          else resolve(blob)
        })
      })
    },
    beginQuote(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/leads/${params.id}/begin_quote`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    confirmQuote(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/leads/${params.id}/quote`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    downloadPdf(ctx, params) {
      return new Promise((resolve, reject) => {
        fetch(`${baseURL}/api/v1/leads/${params.id}/pdf_quote.pdf`, {
          method: 'GET',
          headers: JSON.parse(encryptionService.decrypt(localStorage.getItem('authHeaders'))),
        })
          .then(response => resolve(response.blob()))
          .catch(error => reject(error))
      })
    },
    proceedToIssue(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/leads/${params.id}/proceed_to_issue`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    beginIssue(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/leads/${params.id}/begin_issue`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    confirmIssue(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/leads/${params.lead.id}/confirm_issue`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    leadInformed(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/leads/${params.id}/informed`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
